// extracted by mini-css-extract-plugin
export default {"AppStoreButton__container":"AppStoreWidget_AppStoreButton__container__YzE4M","AppStoreButton__image":"AppStoreWidget_AppStoreButton__image__ZTNlZ"};